<template>
    <div>
        <div v-if="$showModal('applyForm')" class="custom_popup_wrapper">
            <div id="apply_modal" class="custom_popup_inner">
                <div
                    class="b_modal modal_all_details white_modal zoom-anim-dialog"
                >
                    <div class="modal_content_inner">
                        <!--  @TODO - ask client about this button
                    <div class="button_candidate">
                        <button
                            class="btn btn_template btn_candidate"
                            type="button"
                        >
                            הגש מועמדות
                        </button>
                    </div> -->
                        <div class="details_wrapper flex">
                            <div class="details_right">
                                <div class="post_title">
                                    {{ post.title }}
                                </div>
                                <div v-if="post.subtitle" class="sub_title">
                                    {{ post.subtitle }}
                                </div>
                                <div class="image_wrapper">
                                    <div class="block_image">
                                        <picture
                                            v-full-image-path="
                                                post.featuredImage
                                            "
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="details_left">
                                <div class="full_content_wrap">
                                    <div class="full_content">
                                        <div>
                                            <h3>{{ descriptionLabel }}</h3>

                                            <div v-html="post.description" />
                                        </div>
                                        <apply-form
                                            :id="formId"
                                            :form-questions="questions"
                                            is-modal
                                            :hide-title="hideTitle"
                                            @send="onSend"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button
                        title="Close (Esc)"
                        type="button"
                        class="mfp-close"
                        @click="close"
                    >
                        ×
                    </button>
                </div>
            </div>
        </div>
        <boards-thank-you />
    </div>
</template>
<script>
import ApplyForm from '@/components/forms';
import BoardsThankYou from '@/components/modals/BoardsThankYou';

export default {
    components: {
        ApplyForm,
        BoardsThankYou
    },

    props: {
        formId: {
            type: String,
            required: true
        },

        post: {
            type: Object,
            required: true
        },

        questions: {
            type: Array,
            required: true
        },

        descriptionLabel: {
            type: String,
            required: true
        },

        hideTitle: {
            type: Boolean,
            required: true
        }
    },

    methods: {
        onSend() {
            this.$closeModal();

            this.$openModal('boardsThanks');
        },

        close() {
            this.$closeModal();
        }
    }
};
</script>
